import {
  CAPTCHA_VALIDATE_REGISTRATION,
  CAPTCHA_VALIDATE_RESEND_PIN,
  CAPTCHA_VALIDATE_FORGOT_PASSWORD,
  CAPTCHA_VALIDATE_ADD_NUMBER_FOR_NOTIFICATION,
  CAPTCHA_VALIDATE_PAYMENT,
  CAPTCHA_CONFIRM_REGISTRATION,
} from 'api/config'

enum reCaptchaVersion {
  v2 = 2,
  v3 = 3,
}

enum reCaptchaFeature {
  Registration = 1,
  ResendPin = 2,
  ForgotPassword = 3,
  AddNumberForNotification = 4,
  Payment = 5,
  ConfirmRegistration = 6,
}

const isReCaptchaFeatureEnabled = (feature: reCaptchaFeature) => {
  switch (feature) {
    case reCaptchaFeature.Registration:
      return CAPTCHA_VALIDATE_REGISTRATION
    case reCaptchaFeature.ResendPin:
      return CAPTCHA_VALIDATE_RESEND_PIN
    case reCaptchaFeature.ForgotPassword:
      return CAPTCHA_VALIDATE_FORGOT_PASSWORD
    case reCaptchaFeature.AddNumberForNotification:
      return CAPTCHA_VALIDATE_ADD_NUMBER_FOR_NOTIFICATION
    case reCaptchaFeature.Payment:
      return CAPTCHA_VALIDATE_PAYMENT
    case reCaptchaFeature.Payment:
      return CAPTCHA_CONFIRM_REGISTRATION
    default:
      return true
  }
}

export { reCaptchaVersion, reCaptchaFeature, isReCaptchaFeatureEnabled }
